import React, { useEffect, useState } from 'react';
import GameButton from '../../components/GameButton';
import { Dialog, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';
import bg1 from '../../imgs/jogos/bg/bg-3.png';

const questionsData = [
  // Higienização Bucal
  { theme: 'higienizacao-bucal', question: 'Escovar os dentes todos os dias é importante para evitar problemas bucais, como a cárie.', answer: true },
  { theme: 'higienizacao-bucal', question: 'As melhores escovas de dentes são aquelas de cerdas macias e cabeças pequenas.', answer: true },
  { theme: 'higienizacao-bucal', question: 'Só precisamos escovar os dentes ao acordar.', answer: false },
  { theme: 'higienizacao-bucal', question: 'Escovar a língua também faz parte da higiene bucal e ajuda a evitar o mau hálito.', answer: true },
  { theme: 'higienizacao-bucal', question: 'É normal a gengiva sangrar ao usar fio dental, então não é necessário continuar usando.', answer: false },
  { theme: 'higienizacao-bucal', question: 'Alimentos com muito açúcar podem aumentar o risco de cáries se a escovação não for feita corretamente.', answer: true },
  { theme: 'higienizacao-bucal', question: 'Escovar os dentes com força ajuda a remover melhor os restos alimentares.', answer: false },
  { theme: 'higienizacao-bucal', question: 'Devemos escolher sempre pastas de dentes com flúor.', answer: true },
  { theme: 'higienizacao-bucal', question: 'O fio dental deve ser usado pelo menos uma vez ao dia para remover restos de comida e placa entre os dentes.', answer: true },
  { theme: 'higienizacao-bucal', question: 'Ir ao dentista só é necessário quando sentimos dor.', answer: false },

  // Problemas Bucais
  { theme: 'problemas-bucais', question: 'Escovar os dentes depois de comer doces pode reduzir o risco de cáries.', answer: true },
  { theme: 'problemas-bucais', question: 'Usar fio dental não faz diferença na prevenção de cáries.', answer: false },
  { theme: 'problemas-bucais', question: 'A cárie é causada por bactérias que se alimentam do açúcar dos alimentos.', answer: true },
  { theme: 'problemas-bucais', question: 'Se a cárie não for tratada, poderá causar muita dor, infecções graves e até a perda do dente.', answer: true },
  { theme: 'problemas-bucais', question: 'Só crianças têm cáries, adolescentes e adultos não correm risco.', answer: false },
  { theme: 'problemas-bucais', question: 'Pasta de dente com flúor ajuda a diminuir o risco de cárie.', answer: true },
  { theme: 'problemas-bucais', question: 'Gengivite é uma inflamação da gengiva causada pelo acúmulo de placa bacteriana.', answer: true },
  { theme: 'problemas-bucais', question: 'Se a gengiva sangra ao escovar ou passar fio dental, é melhor parar de usar o fio dental.', answer: false },
  { theme: 'problemas-bucais', question: 'A gengivite pode ser curada com boa escovação e uso de fio dental.', answer: true },
  { theme: 'problemas-bucais', question: 'Fumar pode piorar a gengivite.', answer: true },
  { theme: 'problemas-bucais', question: 'Se a gengivite não for tratada corretamente poderá evoluir para a periodontite que é uma doença mais grave, podendo levar a perda dos dentes.', answer: true },
  { theme: 'problemas-bucais', question: 'Usar escova de dente com pasta fluoretada já é suficiente para tratar a gengivite.', answer: false },
  { theme: 'problemas-bucais', question: 'Morder objetos duros, como tampa de caneta ou gelo, pode causar fraturas nos dentes.', answer: true },
  { theme: 'problemas-bucais', question: 'Se um dente quebrar em um acidente, não é necessário procurar um dentista se não houver dor.', answer: false },
  { theme: 'problemas-bucais', question: 'Se um dente permanente sair completamente é necessário lavá-lo suavemente com água, armazenar em água, soro, saliva ou leite e procurar o dentista o mais rápido possível.', answer: true },

  // Saúde Bucal
  { theme: 'saude-bucal', question: 'Usar aparelho ortodôntico sempre dói e machuca a boca.', answer: false },
  { theme: 'saude-bucal', question: 'É preciso ter mais cuidado com a higiene bucal ao usar aparelho ortodôntico.', answer: true },
  { theme: 'saude-bucal', question: 'Quem usa aparelho pode comer qualquer tipo de alimento sem restrições.', answer: false },
  { theme: 'saude-bucal', question: 'Clareamento dental pode ser feito com receitas caseiras, como bicarbonato de sódio e limão.', answer: false },
  { theme: 'saude-bucal', question: 'O clareamento dental é seguro quando realizado sob a supervisão de um dentista.', answer: true },
  { theme: 'saude-bucal', question: 'O clareamento dental deixará seus dentes mais brancos para sempre, sem precisar de cuidados adicionais.', answer: false },
  { theme: 'saude-bucal', question: 'Pessoa de qualquer idade poderá fazer clareamento dental.', answer: false },
  { theme: 'saude-bucal', question: 'Os dentes do siso são os últimos dentes a nascerem na boca e podem causar dor ou desconforto, gengivas inchadas ou sensíveis, dificuldade para abrir a boca ou mastigar e mau hálito ou gosto ruim na boca.', answer: true },
  { theme: 'saude-bucal', question: 'Os dentes do siso sempre precisam ser removidos.', answer: false },
];


function shuffleArray(array) {
  return array.sort(() => Math.random() - 0.5);
}

export default function VerdadeOuMentira({ tema }) {
  const [questions, setQuestions] = useState([]);
  const [current, setCurrent] = useState(0);
  const [score, setScore] = useState(0);
  const [feedback, setFeedback] = useState('');
  const [gameOver, setGameOver] = useState(false);
  const [playerName, setPlayerName] = useState('');
  const [saved, setSaved] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const filtered = tema
      ? questionsData.filter((q) => q.theme === tema)
      : shuffleArray([...questionsData]);
    setQuestions(shuffleArray(filtered.slice(0, 10)));

    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [tema]);

  const handleAnswer = (value) => {
    const currentQuestion = questions[current];
    const isCorrect = currentQuestion.answer === value;
    setFeedback(isCorrect ? '✅ Acertou!' : '❌ Errou!');
    if (isCorrect) setScore(score + 1);

    setTimeout(() => {
      setFeedback('');
      if (current + 1 < questions.length) {
        setCurrent(current + 1);
      } else {
        setGameOver(true);
      }
    }, 2000);
  };

  const handleSave = () => {
    const record = { name: playerName, score, date: new Date().toISOString() };
    const stored = JSON.parse(localStorage.getItem('vm-records') || '[]');
    localStorage.setItem('vm-records', JSON.stringify([...stored, record]));
    setSaved(true);
  };

  if (!questions.length) return <p>Carregando perguntas...</p>;

  const responsiveCard = {
    ...styles.card,
    width: windowWidth < 768 ? '90%' : '100%',
  };

  if (gameOver) {
    const stored = JSON.parse(localStorage.getItem('vm-records') || '[]');
    const ranking = stored.sort((a, b) => b.score - a.score).slice(0, 10);

    return (
      <div style={styles.container}>
        <div style={{ maxWidth: 400, margin: '0 auto' }}>
          <Dialog open={!saved} onClose={() => { }}>
            <DialogTitle>Parabéns! Você terminou o jogo.</DialogTitle>
            <DialogContent>
              <Typography>Você finalizou com <strong>{score}</strong> pontos.</Typography>
              <TextField
                label="Seu nome"
                fullWidth
                value={playerName}
                onChange={(e) => setPlayerName(e.target.value)}
                sx={{ mt: 2, mb: 2 }}
              />
              <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'center' }}>
                <GameButton text="Salvar pontuação" variant="success" onClick={handleSave} disabled={!playerName} style={styles.button} />
              </div>
            </DialogContent>
          </Dialog>
        </div>

        <h2>Fim de jogo!</h2>
        <h3 style={{ marginTop: '30px' }}>🏆 Ranking (Top 10)</h3>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>#</th>
              <th style={styles.th}>Nome</th>
              <th style={styles.th}>Pontuação</th>
              <th style={styles.th}>Data</th>
            </tr>
          </thead>
          <tbody>
            {ranking.map((r, index) => (
              <tr key={index}>
                <td style={styles.td}>{index + 1}</td>
                <td style={styles.td}>{r.name}</td>
                <td style={styles.td}>{r.score}</td>
                <td style={styles.td}>{new Date(r.date).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <div style={{ marginTop: 40 }}>
          <GameButton text="Jogar novamente!" variant="info" onClick={() => window.location.reload()} />
        </div>
      </div>
    );
  }

  return (
    <div style={styles.contain}>
      <Typography variant="h4" gutterBottom>Verdade ou Mentira</Typography>
      <h2 style={styles.heading}>Pergunta {current + 1} de {questions.length}</h2>
      <div style={responsiveCard}>
        <p style={styles.question}>{questions[current].question}</p>
        {feedback ? (
          <p style={styles.feedback}>{feedback}</p>
        ) : (
          <div style={{ ...styles.buttonGroup, flexDirection: windowWidth < 600 ? 'column' : 'row' }}>
            <GameButton text="✅ Verdadeiro" onClick={() => handleAnswer(true)} variant="success" />
            <GameButton text="❌ Falso" onClick={() => handleAnswer(false)} variant="danger" />
          </div>
        )}
      </div>
    </div>
  );
}

const styles = {
  container: {
    padding: '20px',
    textAlign: 'center',
    backgroundColor: '#fff',
    minHeight: '100vh',
  },
  contain: {
    paddingTop: 60,
    paddingBottom: 120,
    width: '100vw',
    minHeight: '100vh',
    overflow: 'hidden',
    background: `url(${bg1}) no-repeat center center`,
    backgroundSize: 'cover',
    fontFamily: 'sans-serif',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  heading: {
    marginBottom: '20px',
    fontSize: '1.5rem',
  },
  card: {
    backgroundColor: '#f5f5f5',
    padding: '30px 20px',
    borderRadius: '16px',
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    minHeight: '150px',
    maxWidth: '600px',
    width: '100%',
    margin: '0 auto',
  },
  question: {
    fontSize: '1.2rem',
    fontWeight: 'bold',
    marginBottom: '20px',
  },
  buttonGroup: {
    display: 'flex',
    justifyContent: 'center',
    gap: '20px',
  },
  feedback: {
    fontSize: '1.1rem',
    fontWeight: '500',
  },
  table: {
    width: '100%',
    maxWidth: '600px',
    margin: '0 auto',
    borderCollapse: 'collapse',
  },
  th: {
    borderBottom: '2px solid #ccc',
    padding: '10px',
  },
  td: {
    borderBottom: '1px solid #eee',
    padding: '10px',
  },
  button: {
    padding: '10px 20px',
    marginTop: '10px',
  },
};